import { render, staticRenderFns } from "./ServicePersonnel.vue?vue&type=template&id=567005ef&scoped=true&"
import script from "./ServicePersonnel.vue?vue&type=script&lang=ts&"
export * from "./ServicePersonnel.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePersonnel.vue?vue&type=style&index=0&id=567005ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567005ef",
  null
  
)

export default component.exports